'use strict';
var React = require('react');
var ReactRedux = require('react-redux');
var BaseComponent = require('../shared/base');
var EnumCoreModule = require('../../public/js/enum-core');

var FooterLayout = require('../layouts/footer').FooterLayoutComponent;

class ForgotPasswordComponent extends BaseComponent {
    resetPassword() {
        $('#frmReset').submit();
    }

    componentDidMount() {
        if (this.props.success === 'false') {
            $('input[name="username"]').addClass('error-con');
        }
    }

    render() {
        let backUrl = `/accounts/${this.props.type}/sign-in`;
        if (this.props.type === 'non-private') {
            backUrl += `?isSeller=${this.props.isSeller || false}`;
        }

        return (
            <div id="container-forgot-password">
                <div className="login-container">
                    <div className="icon-logo">
                        {/*<img src={this.props.marketplaceLogoUrl} /> */}
                        {<img alt="" id="icon-megamak-login" src="/assets/images/bepensa/logo-megamak-hd.png"></img>}
                    </div>
                    <div className="login-box">
                        {/* <div className="lb-head full-width head-buyer subcontainer-login">
                            <a href={backUrl}>
                                <img src="/assets/images/back.svg" /></a> <span>Olvidó su contraseña</span>
                        </div> */}
                        <div className="lb-body full-width">
                            <form id="frmReset" action="/accounts/forgot-password" method="post" autoComplete="off">
                                <h2>Olvidó su contraseña</h2>
                                <div className="lbb-input">
                                    <p align="left">Escribe la dirección de correo electrónico o el nombre de usuario asociado a tu cuenta.</p>
                                    <input type="hidden" className="input-text" name="type" value={this.props.type} />
                                    <input type="hidden" className="input-text" name="isSeller" value={this.props.isSeller || false} />
                                    <input id="input-forgot-password" type="text" className="input-text required" onKeyDown={(e) => this.avoidWhiteSpaceOnKeyDown(e)} placeholder="Correo / Usuario" name="username" />
                                </div>
                                <div className="btn-signin"> <a href="#" onClick={(e) => this.resetPassword()}>Cambiar contraseña</a> </div>
                                <div className="field-empty" style={{ display: this.props.success === 'false' ? 'block' : 'none'}}>
                                    <p align="left">Lo sentimos. No pudimos encontrar una cuenta con el correo electrónico / nombre de usuario.</p>
                                </div>
                                <div className={this.props.success === 'true' ? "recovery-accept" : "recovery-accept hide"}>
                                    <p align="left">Se envió un correo electrónico de recuperación a la dirección de correo electrónico asociada con esta cuenta..</p>
                                </div>
                            </form>
                            <span className="lbb-text"><a className="lbl-link" href={backUrl}>Regresar</a></span>
                        </div>
                    </div>

                    
                </div>
                <div className="footer" id="footer-section">
                        <FooterLayout panels={this.props.panels} />
                </div>
            </div>

            
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        marketplaceLogoUrl: state.marketplaceLogoUrl,
        success: state.success,
        type: state.type,
        isSeller: state.isSeller
    }
}

function mapDispatchToProps(dispatch) {
    return {}
}

const ForgotPasswordHome = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPasswordComponent)

module.exports = {
    ForgotPasswordHome,
    ForgotPasswordComponent
}